import React, { FC } from 'react'
import { Field, InjectedFormProps, reduxForm } from 'redux-form'
import { Col, Collapse, Form, Row } from 'antd'
import { useTranslation } from 'react-i18next'
import { debounce } from 'lodash'
import { useSelector } from 'react-redux'
import { RootState } from '../../reducers'

// atoms
import SelectField from '../../atoms/SelectField'
import CodeEditorField from '../../atoms/CodeEditorField'

// interfaces
import { IFormItemData } from '../../types/interfaces'

// utils
import { FORM, RENDER_LABEL_TYPE } from '../../utils/enums'

// assets
import { ReactComponent as ChevronIcon } from '../../assets/icons/BaseIcons/chevron-down-1-icon.svg'

const { Panel } = Collapse

type ComponentProps = {
	elementType: string
	onSubmit: any
}

type Props = InjectedFormProps<IFormItemData, ComponentProps> & ComponentProps

const ElementCSSForm: FC<Props> = (props) => {
	const { t } = useTranslation()
	const { handleSubmit, elementType } = props
	const disable = useSelector((state: RootState) => state.formTemplate.disable)

	const renderLabel = (type: string) => {
		switch (type) {
			case RENDER_LABEL_TYPE.PARAGRAPH:
				return t('loc:Paragraph')
			case RENDER_LABEL_TYPE.INPUT:
				return t('loc:Input')
			case RENDER_LABEL_TYPE.DROPDOWN_BUTTON:
				return t('loc:Dropdown')
			case RENDER_LABEL_TYPE.CHECK_BOX:
				return t('loc:Checkbox')
			case RENDER_LABEL_TYPE.RADIO_BUTTON:
				return t('loc:Radio')
			case RENDER_LABEL_TYPE.TEXT_AREA:
				return t('loc:Text area')
			case RENDER_LABEL_TYPE.HORIZONTAL_LINE:
				return t('loc:Horizontal line')
			case RENDER_LABEL_TYPE.DATE_PICKER:
				return t('loc:Date/Time picker')
			case RENDER_LABEL_TYPE.BUTTON:
				return t('loc:Button')
			case RENDER_LABEL_TYPE.TABLE:
				return t('loc:Table')
			case RENDER_LABEL_TYPE.TITLE:
				return t('loc:Title')
			case RENDER_LABEL_TYPE.TAB_BOX:
				return t('loc:Tabs')
			case 'image':
				return t('loc:Image')
			case RENDER_LABEL_TYPE.SELECT_FROM_TABLE:
				return t('loc:Select from table')
			default:
				return ''
		}
	}

	return (
		<Form layout={'vertical'} onSubmitCapture={handleSubmit}>
			<h3 className={'ml-4 mb-4'}>{renderLabel(elementType)}</h3>
			<Collapse expandIcon={({ isActive }) => <ChevronIcon rotate={isActive ? 0 : 180} />} expandIconPosition={'end'} ghost>
				<Panel header={t('loc:Inherit classes')} key='1'>
					<Row justify={'center'} className={'my-2 w-full'}>
						<Col span={24}>
							<Field component={SelectField} name={'inheritClasses'} options={[]} size={'medium'} mode={'tags'} disabled={disable} />
						</Col>
					</Row>
				</Panel>
				<Panel header={t('loc:Custom CSS')} key='2'>
					<Row justify={'center'} className={'mt-2 mb-2 w-full'}>
						<Col span={24}>
							<Field component={CodeEditorField} language={'css'} minHeight={160} className={'css-editor'} name={'css'} disabled={disable} />
						</Col>
					</Row>
				</Panel>
			</Collapse>
		</Form>
	)
}

const form = reduxForm<IFormItemData, ComponentProps>({
	form: FORM.ELEMENT_CSS_FORM,
	forceUnregisterOnUnmount: true,
	touchOnChange: true,
	destroyOnUnmount: true,
	onChange: debounce((values, dispatch, props) => {
		if (props.anyTouched) {
			props.submit()
		}
	}, 600)
})(ElementCSSForm)

export default form
